import * as React from 'react';

import { motion } from 'framer-motion';
import { useTheme } from 'styled-components';

export interface ArrowIconProps {
  className?: string;
  color?: string;
  customColor?: string;
  size?: number;
  up?: boolean;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const ArrowIcon: React.FC<ArrowIconProps> = (props) => {
  const variants = {
    down: { rotate: 0 },
    up: { rotate: 180 },
  };

  const theme = useTheme();

  const getColor = (color: any) => {
    switch (color) {
      case 'dark':
        return theme.colors.primary;
      case 'red':
        return theme.colors.accent;
      default:
        return 'white';
    }
  };

  return (
    <svg
      width={props.size ? props.size : '16px'}
      height={props.size ? props.size : '16px'}
      viewBox="0 0 16 16"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
      preserveAspectRatio="none"
    >
      <motion.g
        initial="down"
        animate={props.up ? 'up' : 'down'}
        exit="down"
        variants={variants}
      >
        <path
          fill={props.customColor ? props.customColor : getColor(props.color)}
          d="M3.8 9.1c-0.4 0.4-0.4 1 0 1.4 0.4 0.4 1 0.4 1.4 0L8 7.6l2.8 2.8c0.4 0.4 1 0.4 1.4 0 0.4-0.4 0.4-1 0-1.4L8.7 5.5C8.3 5.2 7.8 5.1 7.4 5.4L7.3 5.5 3.8 9.1z"
        />
      </motion.g>
    </svg>
  );
};

export default ArrowIcon;
